import { LIST_FEATURES } from 'src/utils/constants/featuresPoint';
import { URL_ENDPOINT } from 'src/utils/constants/service';

export enum EXPORT_TABLE_TYPE {
  TRADE_DATA_MARKET_ANALYTICS_BUYER_LIST = 'TRADE_DATA_MARKET_ANALYTICS_BUYER_LIST',
  TRADE_DATA_MARKET_ANALYTICS_SUPPLIER_LIST = 'TRADE_DATA_MARKET_ANALYTICS_SUPPLIER_LIST',
  TRADE_DATA_SUPPLIERS_COUNTRY_SUPPLIER_LIST = 'TRADE_DATA_SUPPLIERS_COUNTRY_SUPPLIER_LIST',
  TRADE_DATA_BUYERS_COUNTRY_BUYER_LIST = 'TRADE_DATA_BUYERS_COUNTRY_BUYER_LIST',
  TRADE_DATA_BUYERS_SUPPLIER_LIST = 'TRADE_DATA_BUYERS_SUPPLIER_LIST',
  TRADE_DATA_SUPPLIERS_BUYER_LIST = 'TRADE_DATA_SUPPLIERS_BUYER_LIST',

  CTD_ANALYTICS = 'CTD_ANALYTICS',
  CTD_ANALYTICS_BUYERS = 'CTD_ANALYTICS_BUYERS',
  CTD_ANALYTICS_SUPPLIERS = 'CTD_ANALYTICS_SUPPLIERS',
  CTD_BUYERS = 'CTD_BUYERS',
  CTD_SUPPLIERS = 'CTD_SUPPLIERS',
  CTD_HS_CODE = 'CTD_HS_CODE',
  CTD_POO = 'CTD_POO',
  CTD_POD = 'CTD_POD',
  CTD_POO_BUYERS = 'CTD_POO_BUYERS',
  CTD_POO_SUPPLIERS = 'CTD_POO_SUPPLIERS',
  CTD_POD_BUYERS = 'CTD_POD_BUYERS',
  CTD_POD_SUPPLIERS = 'CTD_POD_SUPPLIERS',
  CTD_TRADING_AREA = 'CTD_TRADING_AREA',
  CTD_COMPETITOR = 'CTD_COMPETITOR',
}

export const URL_EXPORT_MAPPING = {
  [LIST_FEATURES.TRADE_DATA_MARKET_ANALYTICS]: URL_ENDPOINT.tradeData.exportMarketAnalytic,
  [LIST_FEATURES.TRADE_DATA_BUYER_COUNTRY]: URL_ENDPOINT.tradeData.exportBuyerCountry,
  [LIST_FEATURES.TRADE_DATA_SUPPLIER_COUNTRY]: URL_ENDPOINT.tradeData.exportSupplierCountry,
  [LIST_FEATURES.TRADE_DATA_PORT_OF_ORIGIN]: URL_ENDPOINT.tradeData.exportPortOrigin,
  [LIST_FEATURES.TRADE_DATA_PORT_OF_DELIVERY]: URL_ENDPOINT.tradeData.exportPortDelivery,
  [LIST_FEATURES.TRADE_DATA_BUYERS]: URL_ENDPOINT.tradeData.exportBuyer,
  [LIST_FEATURES.TRADE_DATA_SUPPLIERS]: URL_ENDPOINT.tradeData.exportSupplier,
  [EXPORT_TABLE_TYPE.TRADE_DATA_MARKET_ANALYTICS_BUYER_LIST]: URL_ENDPOINT.tradeData.exportMarketAnalyticBuyer,
  [EXPORT_TABLE_TYPE.TRADE_DATA_MARKET_ANALYTICS_SUPPLIER_LIST]: URL_ENDPOINT.tradeData.exportMarketAnalyticSupplier,
  [EXPORT_TABLE_TYPE.TRADE_DATA_SUPPLIERS_COUNTRY_SUPPLIER_LIST]: URL_ENDPOINT.tradeData.exportSuppliersCountrySupplier,
  [EXPORT_TABLE_TYPE.TRADE_DATA_BUYERS_COUNTRY_BUYER_LIST]: URL_ENDPOINT.tradeData.exportBuyersCountryBuyer,
  [EXPORT_TABLE_TYPE.TRADE_DATA_BUYERS_SUPPLIER_LIST]: URL_ENDPOINT.tradeData.exportBuyersSupplier,
  [EXPORT_TABLE_TYPE.TRADE_DATA_SUPPLIERS_BUYER_LIST]: URL_ENDPOINT.tradeData.exportSuppliersBuyer,

  [EXPORT_TABLE_TYPE.CTD_ANALYTICS]: URL_ENDPOINT.tradeDataWithoutHSCode.analytics.export,
  [EXPORT_TABLE_TYPE.CTD_ANALYTICS_BUYERS]: URL_ENDPOINT.tradeDataWithoutHSCode.analytics.buyersExport,
  [EXPORT_TABLE_TYPE.CTD_ANALYTICS_SUPPLIERS]: URL_ENDPOINT.tradeDataWithoutHSCode.analytics.suppliersExport,
  [EXPORT_TABLE_TYPE.CTD_BUYERS]: URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.buyerExport,
  [EXPORT_TABLE_TYPE.CTD_SUPPLIERS]: URL_ENDPOINT.tradeDataWithoutHSCode.buyerSupplier.supplierExport,
  [EXPORT_TABLE_TYPE.CTD_HS_CODE]: URL_ENDPOINT.tradeDataWithoutHSCode.hsCode.export,
  [EXPORT_TABLE_TYPE.CTD_POO]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOExport,
  [EXPORT_TABLE_TYPE.CTD_POD]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODExport,
  [EXPORT_TABLE_TYPE.CTD_POO_BUYERS]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOBuyersExport,
  [EXPORT_TABLE_TYPE.CTD_POO_SUPPLIERS]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.POOSuppliersExport,
  [EXPORT_TABLE_TYPE.CTD_POD_BUYERS]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODBuyersExport,
  [EXPORT_TABLE_TYPE.CTD_POD_SUPPLIERS]: URL_ENDPOINT.tradeDataWithoutHSCode.portOfOriginPortOfDelivery.PODSuppliersExport,
  [EXPORT_TABLE_TYPE.CTD_TRADING_AREA]: URL_ENDPOINT.tradeDataWithoutHSCode.tradingArea.export,
  [EXPORT_TABLE_TYPE.CTD_COMPETITOR]: URL_ENDPOINT.tradeDataWithoutHSCode.competitor.export,
} as const;
